module.exports = jQuery;


/*****************
 ** WEBPACK FOOTER
 ** external "jQuery"
 ** module id = 34
 ** module chunks = 0
 **/